export default __webpack_public_path__ + "static/media/Strugani 25.abcc8233.jpg";